import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const UPDATE = graphql(`
  mutation updateTopBanner($id: ID!, $input: UpdateTopBannerInput!) {
    updateTopBanner(id: $id, input: $input) {
      ...TopBannerItem
    }
  }
`);

export function useUpdateTopBanners() {
  return useMutation(UPDATE, {
    refetchQueries: ['topBanners', 'topBanner'],
  });
}
